import React, { useEffect }  from 'react';
import axios from 'axios';
import { renderImporter } from "hello-csv/bundled";

const App = ({id, sheets, submitUrl}) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/hello-csv@0.1.1/dist/bundled/hello-csv.css';
    document.head.appendChild(link);
    
    renderImporter(document.getElementById(id), {
      sheets,
      onComplete: onCompleteWithSubmitUrl
    });
  }, []);
  const onCompleteWithSubmitUrl = (data) => {
    axios.post(submitUrl, {data: data.sheetData}).then((response) => {
      console.log(response)
    });
  }
  return (
    <div id={id}></div>
  )
};

export default App;
